module.exports = __webpack_public_path__ + "img/frame-head-mb.0704cc3e.webp";